import { CardContainer } from "src/components/shared/Card/Card.styled";
import { IGroupedLog } from "src/interfaces/ChecklistLogbooks";
import { Flex } from "src/styled";

type Props = {
  label: string;
  value: string;
  onClick: (name: string) => void;
};

const ChecklistLogbookCard = ({ label, value, onClick }: Props) => {
  return <CardContainer onClick={() => onClick(label)}>{label}</CardContainer>;
};
export default ChecklistLogbookCard;
